import React, {useEffect} from "react";
import './Terms.css'
import {useLanguage} from "../context/LanguageContext";

const TermsAndConditions = (props) => {

  const packInfoArray = [
      // {price: "2.10 AED/day", unsubCode: "UNSUB dtoonz to 4273"},
      {price: "3.15 AED/day", unsubCode: "UNSUB bindie to 4273"},
      {price: "12.60 AED/week", unsubCode: "UNSUB wbindie to 4273"}
  ]
  const packInfoArray_ar = [
    // {price: "2.10 AED/day", unsubCode: "UNSUB dtoonz to 4273"},
    {price: "3.25 د إ/ يوميا(مضمنة ضريبة القيمة المضافة)", unsubCode: "UNSUB bindie to 4273"},
    {price: "12.06 درهم اماراتي/ أسبوعيا(مضمنة ضريبة القيمة المضافة)", unsubCode: "UNSUB wbindie to 4273"}
  ]
  const { language, setLanguage } = useLanguage();

  // useEffect(() => {
  //   console.log("From MobileEntry > ", packInfoArray[props.pack]);
  // }, [props.pack]);

  return (
      language === "en" ? (
    <div className="terms_section">
      <div className="row">
        <div className="col-lg-12">
          <h4 className="head">Terms & Conditions</h4>
          <ul>
            <li>
              By proceeding, you are agreeing to Etisalat Terms &amp; Conditions
              and Privacy Policy (visit etisalat.ae)
            </li>
            <li>
              Enjoy <span className="freetr">24 hours</span> Free trial (The
              free trial is valid only for new subscribers)
            </li>
            <li>
              After free trial, charges are{" "} 
              <span className="dyprice">{packInfoArray[props.pack].price}</span>
               (incl. VAT)
            </li>
            <li>Paid subscription starts after free trial automatically</li>
            <li>
              No commitment, you can cancel your subscription at any time by
              sending <span className="unsubkey">{packInfoArray[props.pack].unsubCode}</span>

            </li>
            <li>
              For support, please contact supportae@bestindie.co or call 900 0321300
            </li>
            <li>
              Please make sure that your browser is not using any 3rd-party
              blocking technologies and you have a healthy internet connection
              for swift access to the content.
            </li>
          </ul>
        </div>
      </div>
    </div>
          )

          : (
              <div className="terms_section_ar">
                <div className="row">
                  <div className="col-lg-12">
                    <h4 className="head">الشروط والأحكام</h4>
                    <ul>
                      <li>بالمتابعة ، فإنك توافق على شروط واحكام اتصالات وسياسة الخصوصية

                      </li>
                      <li>
                        تمتع ب 24 ساعة المجانية (الفترة المجانية هي فقط للمشتركين الجدد)
                      </li>
                      <li>
                        بعد الفترة المجانية, ستكون قيمة الخدمة <span className="dyprice" >{packInfoArray_ar[props.pack].price}</span>
                      </li>
                      <li>
                        يبدأ الاشتراك المدفوع بعد انتهاء الفترة المجانية بشكل تلقائي
                      </li>
                      <li>
                          لا يوجد التزام, يمكنك الغاء اشتراكك في أي وقت عن طريق ارسال <span
                          className="unsubkey">{packInfoArray_ar[props.pack].unsubCode}</span>
                      </li>
                      <li>للدعم, تواصل معنا عبر supportae@bestindie.co</li>

                      <li>
                        يرجى التأكد من أن متصفحك لا يستخدم أي تقنيات حظر تابعة لجهات خارجية وأن لديك اتصال إنترنت صحي للوصول السريع إلى المحتوى
                      </li>
                    </ul>
                  </div>
                </div>
              </div>


          )

  )
      ;
    }
;

export default TermsAndConditions;